import { render, staticRenderFns } from "./CommentPanelHeader.vue?vue&type=template&id=6943d8e8&scoped=true&"
import script from "./CommentPanelHeader.vue?vue&type=script&lang=ts&"
export * from "./CommentPanelHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CommentPanelHeader.vue?vue&type=style&index=0&id=6943d8e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6943d8e8",
  null
  
)

export default component.exports